<ng-container>
  <div class="w-full flex justify-center mt-3">
    <div class="edit-vehicle-dialog-container flex flex-col px-6 py-1.5 w-full max-w-3xl">
      <span class="text-base font-semibold pb-9" style="font-family: 'Open Sans';">{{dialogData.vehicle ?
        dialogData.vehicle.year + ' ' + dialogData.vehicle.make + ' ' + dialogData.vehicle.model + ' (ID: ' +
        dialogData.vehicle?.id + ')' : dialogData.appointment.vehicleDescription}}</span>
      <div class="flex flex-col">
        <form id="vehicleForm" class="flex flex-col w-full space-y-3" [formGroup]=dialogData.vehicleForm>
          <div class="flex flex-row space-x-6">
            <div class="flex flex-col w-1/3" *ngIf="dialogData.filteredAssociates$ | async as filteredAssociates">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                Owner Name (First, Last)<sup>*</sup></span>
              <mat-form-field appearance="outline" class="text-sm">
                <input #associateName matInput autocomplete="off" id="dank" aria-label="Associate"
                  [matAutocomplete]="auto" formControlName="name" required (change)="saveTypedName($event.target.value)"
                  #trigger="matAutocompleteTrigger">
                <mat-autocomplete #auto="matAutocomplete" autocomplete="dank"
                  [displayWith]="displayAssociateName.bind(auto,filteredAssociates)"
                  (optionSelected)="selectAssociate($event.option.value,filteredAssociates)">
                  <mat-option value="addAssociate">-- Add Associate --</mat-option>
                  <mat-option *ngFor="let associate of filteredAssociates" [value]="associate.id">
                    <span>{{associate.nameAddress}}</span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('name').errors">
                  {{dialogData.vehicleForm.get('name').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3"
                style="font-family: 'Open Sans'; color: #282828">Year<sup>*</sup></span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="year" matInput formControlName="year" required maxlength="4" type="text" inputmode="numeric"
                  autocomplete="off">
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('year').errors">
                  {{dialogData.vehicleForm.get('year').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3"
                style="font-family: 'Open Sans'; color: #282828">Make<sup>*</sup></span>
              <mat-form-field appearance="outline" class="text-sm">
                <mat-select formControlName="make" required>
                  <mat-option *ngFor="let make of dialogData.vehicleDropdowns.makes" [value]="make.description">
                    {{make.description}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('make').errors">
                  {{dialogData.vehicleForm.get('make').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row space-x-6">
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3"
                style="font-family: 'Open Sans'; color: #282828">Model<sup>*</sup></span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="model" matInput formControlName="model" required autocomplete="off">
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('model').errors">
                  {{dialogData.vehicleForm.get('model').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Body</span>
              <mat-form-field appearance="outline" class="text-sm">
                <input #vehicleBody matInput autocomplete="off" id="vehicleBody" aria-label="Body"
                  [matAutocomplete]="vehicleBodyAuto" formControlName="body">
                <mat-autocomplete #vehicleBodyAuto="matAutocomplete" autocomplete="vehicleBody">
                  <mat-option *ngFor="let body of dialogData.bodyDropdowns$ | async" [value]="body.vehicleBody">
                    <span>{{body.vehicleBody}}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">VIN</span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="vin" matInput formControlName="vin" oninput="this.value = this.value.toUpperCase()"
                  autocomplete="off">
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row space-x-6">
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Engine</span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="engine" matInput formControlName="engine" autocomplete="off">
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                Plate Number</span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="licensePlateNumber" matInput formControlName="licensePlateNumber"
                  oninput="this.value = this.value.toUpperCase()" autocomplete="off">
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3"
                style="font-family: 'Open Sans'; color: #282828">Odometer<sup>*</sup></span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="currentMileage" matInput formControlName="currentMileage"
                  [textMask]="{mask: numberMask, guide: false}" required type="text" inputmode="numeric"
                  autocomplete="off">
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('currentMileage').errors">
                  {{dialogData.vehicleForm.get('currentMileage').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row pr-12 space-x-6">
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                Prospect Color</span>
              <mat-form-field appearance="outline" class="text-sm">
                <mat-select formControlName="prospectColourId">
                  <mat-option *ngFor="let colour of dialogData.vehicleDropdowns.colours" [value]="colour.id">
                    {{colour.colourDescription}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/3">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                In-Service Date</span>
              <mat-form-field appearance="outline" class="text-sm">
                <input [matDatepicker]="deliveryDatePicker" id="deliveryDate" matInput formControlName="deliveryDate"
                  [max]="maxDate" type="text" inputmode="numeric">
                <mat-error *ngIf="formSubmitted && dialogData.vehicleForm.get('deliveryDate').errors">
                  {{dialogData.vehicleForm.get('deliveryDate').errors | inputError}}
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #deliveryDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <div class="w-full h-full bg-white mt-10">
        <div class="flex flex-row place-content-end items-center">
          <span (click)="cancel()" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md"
            [ngStyle]="{ border: '1px solid #515251', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px">Cancel</span>
          <button (click)="save(dialogData.vehicleForm, dialogData.associateForm,dialogData.addressForm)"
            id="saveButton" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
            [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px" type="submit">
            <span class="text-white font-medium text-sm">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>